module.exports = __webpack_public_path__ + "static/08-fbaabc52aa9e58f63940811698833e4a.jpg";